import "./campaignResultSkeleton.scss";

export default function CampaignResultSkeleton() {
  return (
    <div className="campaign-result-skeleton-container">
      <div
        className="campaign-result-skeleton"
        style={{ width: "30%", height: "25px" }}
      />
      <hr style={{ width: "100%" }} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          className="campaign-result-skeleton"
          style={{ width: "40%", height: "25px" }}
        />
        <div
          className="campaign-result-skeleton"
          style={{ width: "30%", height: "25px" }}
        />
      </div>
      <div
        className="campaign-result-skeleton"
        style={{
          width: "100%",
          height: "100%",
          aspectRatio: "1",
          maxWidth: "300px",
          maxHeight: "300px",
          alignSelf: "center",
          borderRadius: "100%",
        }}
      />
    </div>
  );
}
